export const INJURY_STATUS_NEW = 0
export const INJURY_STATUS_PENDING_MANAGER = 1
export const INJURY_STATUS_APPROVED_MANAGER = 2
export const INJURY_STATUS_REJECTED_MANAGER = 3
export const INJURY_STATUS_FOR_CONSIDERATION = 4
export const INJURY_STATUS_ASSET_DISCARDED = 5
export const INJURY_STATUS_ASSET_UNDER_REPAIR = 6
export const INJURY_STATUS_ASSET_REPAIRED = 7

export const injuryReportStillOpen = (statusId: number) =>
  [
    INJURY_STATUS_NEW,
    INJURY_STATUS_PENDING_MANAGER,
    INJURY_STATUS_FOR_CONSIDERATION,
    INJURY_STATUS_ASSET_UNDER_REPAIR,
  ].includes(statusId)
